import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { getUA, isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import { Spinner } from "react-bootstrap";
import { hotjar } from "react-hotjar";

import { APPLICATION_STEPS as FEDERAL_APPLICATION_STEPS } from "../../../../constants/V2-federal/progress";
import { APPLICATION_STEPS as REFLECTION_1_APPLICATION_STEPS } from "../../../../constants/V2-reflection-1/progress";
import { APPLICATION_STEPS as REFLECTION_2_APPLICATION_STEPS } from "../../../../constants/V2-reflection-2/progress";
import { APPLICATION_STEPS as REFLECTION_3_APPLICATION_STEPS } from "../../../../constants/V2-reflection-3/progress";
import { APPLICATION_STEPS as REFLECTION_4_APPLICATION_STEPS } from "../../../../constants/V2-reflection-4/progress";

import * as actionCreator from "../../../../../store/actions/productActions";
import { setItemLocalStorage } from "../../../../../variables/Variables";
import { checkDate } from "../../../../../helpers/dateChecker";
import { usePrevious } from "../../../../hooks";

import BasicHeaderSection from "../../../sections/BasicHeaderSection";
import FormSection from "../../../sections/FormSection";
import FormSectionFederal from "../../../V2-federal/sections/FormSection";
import ProgressSectionFederal from "../../../V2-federal/sections/ProgressSection";
import FormSectionReflection1 from "../../../V2-reflection-1/sections/FormSection";
import ProgressSectionReflection1 from "../../../V2-reflection-1/sections/ProgressSection";
import FormSectionReflection2 from "../../../V2-reflection-2/sections/FormSection";
import ProgressSectionReflection2 from "../../../V2-reflection-2/sections/ProgressSection";
import FormSectionReflection3 from "../../../V2-reflection-3/sections/FormSection";
import ProgressSectionReflection3 from "../../../V2-reflection-3/sections/ProgressSection";
import FormSectionReflection4 from "../../../V2-reflection-4/sections/FormSection";
import ProgressSectionReflection4 from "../../../V2-reflection-4/sections/ProgressSection";
import FormSectionFileforein from "../../../V2-fileforein/sections/FormSection";
import ProgressSectionFileforein from "../../../V2-fileforein/sections/ProgressSection";

import ErrorMessage from "../../../ErrorMessage";
import ErrorMessageFederal from "../../../V2-federal/ErrorMessage";
import ErrorMessageReflection1 from "../../../V2-reflection-1/ErrorMessage";
import ErrorMessageReflection2 from "../../../V2-reflection-2/ErrorMessage";
import ErrorMessageReflection3 from "../../../V2-reflection-3/ErrorMessage";
import ErrorMessageReflection4 from "../../../V2-reflection-4/ErrorMessage";

const StyledEINSolePropPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  min-height: calc(100vh - 100px);

  @media ${({ theme }) => theme.devices.tablet} {
    min-height: calc(100vh - 80px);
  }
`;

const StyledEINSolePropPageFederal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledEINSolePropPageReflection1 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;

const StyledEINSolePropPageReflection2 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;
const StyledEINSolePropPageReflection3 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;
const StyledEINSolePropPageReflection4 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`;
function EINSolePropPage() {
  const dispatch = useDispatch();
  const products = useSelector(({ products }) => products);
  const router = useRouter();
  const [submitted, setSubmitted] = useState(false);

  const [state, setState] = useState(() => {
    const initState = {
      code: "EIN_SoleProp",
      step: (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "federaltaxid" || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein" || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-1" || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-2" || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-3" || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-4") && isMobile ? 1 : 7,
      dbaname: "",
      ownerFirstName: "",
      ownerMiddleName: "",
      ownerLastName: "",
      ownerSSN: "",
      ownerSuffixName: "",
      ownerTitle: "",
      activityReasonForApplying: "",
      activityPrimaryActivity: "",
      activitySpecificProducts: "",
      productExtraQuestion1: "",
      productExtraQuestion2: "",
      productExtraQuestion3: "",
      productExtraQuestion4: "",
      productDescription: "",
      acceptCreditCardPayments: "false",
      payEmployeesViaPayroll: "false",
      questionsAppliedBefore: "false",
      questionsHire: "false",
      questionsExcise: "false",
      questionsATF: "false",
      questionsGambling: "false",
      questionsHighway: "false",
      payLessThan4k: "false",
      annualTaxes: "false",
      previousEINNumberFirst2: "",
      previousEINNumberLast7: "",
      numberOfAgricultureEmployees: "0",
      numberOfHouseholdeEmployees: "0",
      numberOfOtherEmployees: "0",
      firstDateWagesMonth: new Date().getMonth() + 1,
      firstDateWagesDay: new Date().getDate(),
      firstDateWagesYear: new Date().getFullYear(),
      firstDateWagesIsValid: true,
      corpAddressAddress1: "",
      corpAddressAddress2: "",
      corpAddressCity: "",
      corpAddressState: "",
      corpAddressCountry: "US",
      corpAddressZip: "",
      corpAddressCounty: "",
      altAddress: "false",
      altAddressAddress1: "",
      altAddressAddress2: "",
      altAddressCity: "",
      altAddressState: "",
      altAddressCountry: "US",
      altAddressZip: "",
      altAddressCounty: "",
      customerPhone: "",
      customerEmail: "",
      closingMonth: "12",
      startDateYear: new Date().getFullYear(),
      startDateDay: new Date().getDate(),
      startDateMonth: new Date().getMonth() + 1,
      loading: true,
      validated: false,
      verifying: false,
      suspendedSubmit: false,
    };

    const product = JSON.parse(localStorage.getItem("product"));
    const historyPath = localStorage.getItem("path");

    if (historyPath && historyPath === "EINSoleProp" && product) {
      return { ...initState, ...product, suspendedSubmit: false };
    }

    return initState;
  });

  const prevState = usePrevious(state);

  const isProductsEmpty = !products.products.length;
  const isError = Boolean(products.error);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleNextStep = () => {
    window.scrollTo(0, 0);
    document.querySelector("#EINForm").classList.remove("was-validated");
    setState(prevState => ({ ...prevState, step: prevState.step + 1, validated: false }));
  };

  const handleBackStep = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.scrollTo(0, 0);
    document.querySelector("#EINForm").classList.remove("was-validated");
    setState(prevState => ({ ...prevState, step: prevState.step - 1, validated: false }));
  };

  const handleChange = (e, extraValues = {}) => {
    const { id, name, value } = e.target || {};
    setState(prevState => {
      const { questionsHire, ...restState } = prevState;
      if (id?.toString().indexOf("Date") !== -1 && questionsHire === "true") {
        return {
          ...prevState,
          [name || id]: value,
          firstDateWagesIsValid: checkDate({ id, value }, restState),
          ...extraValues,
        };
      }

      return { ...prevState, [name || id]: value, ...extraValues };
    });
  };

  const handleSubmit = useCallback((e) => {
    e.preventDefault();

    if (state.verifying) {
      return;
    }

    setState(prevState => ({ ...prevState, suspendedSubmit: false }));

    const form = e.currentTarget;
    const product = products.products.filter((u) => u.code.replace("_", "").includes("EINSoleProp"))[0];

    const productInfo = {
      ...state,
      customerName: product.customerName,
      code: product.code,
      device: isMobile && !getUA.includes("Intel") ? "MOBILE" : "DESKTOP",
    };

    localStorage.setItem("product", JSON.stringify(productInfo));
    localStorage.setItem("path", "EINSoleProp");

    dispatch(actionCreator.logOrder(productInfo));
    setState(prevState => ({ ...prevState, validated: true }));

    const section1 = document.querySelector(".is-invalid");
    if (section1 != null) {
      section1.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      if (form.checkValidity() === false) {
        e.stopPropagation();
        document.querySelector("#EINForm").classList.add("was-validated");
        const section = document.querySelector(".form-control:invalid") || document.querySelector(".custom-control-invalid");
        section && section?.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        if (state.step === 7) {
          if (state.questionsHire === "false" || state.firstDateWagesIsValid) {
            hotjar.event("lead_form_submitted");
            setSubmitted(true);
            dispatch(actionCreator.solePropEinOrder(productInfo, router));
          }
        } else {
          handleNextStep();
        }
      }
    }
  }, [dispatch, router, products, state, handleNextStep]);

  const handleTryAgain = useCallback(() => {
    dispatch(actionCreator.clearErrorMessage());
  }, [dispatch]);

  useEffect(() => {
    setItemLocalStorage("product", state);
    localStorage.setItem("path", "EINSoleProp");
  }, [state]);

  useEffect(() => {
    if (prevState?.verifying && !state.verifying && state.suspendedSubmit) {
      document.getElementById("EINSubmitButton")?.click();
    }
  }, [state, prevState]);

  useEffect(() => {
    dispatch(actionCreator.getProducts());
    dispatch(actionCreator.clearErrorMessage());
  }, [dispatch]);

  useEffect(() => {
    if (isError && submitted) {
      setSubmitted(false);
    }
  }, [isError, submitted]);

  if (isProductsEmpty) {
    return (
      <StyledEINSolePropPage />
    );
  }

  if (submitted) {
    return (
      <StyledEINSolePropPage>
        <Spinner animation="border" variant="secondary" />
      </StyledEINSolePropPage>
    );
  }

  if (isError) {
    if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "federaltaxid" || process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein") {
      return (
        <StyledEINSolePropPage>
          <ErrorMessageFederal
            showOK={{
              text: "Try Again",
              onClick: handleTryAgain,
            }}
            message={(<span>Something went wrong</span>)}
            error={products.error}
          />
        </StyledEINSolePropPage>
      );
    }

    if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-1") {
      return (
        <StyledEINSolePropPage>
          <ErrorMessageReflection1
            showOK={{
              text: "Try Again",
              onClick: handleTryAgain,
            }}
            message={(<span>Something went wrong</span>)}
            error={products.error}
          />
        </StyledEINSolePropPage>
      );
    }

    if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-2") {
      return (
        <StyledEINSolePropPage>
          <ErrorMessageReflection2
            showOK={{
              text: "Try Again",
              onClick: handleTryAgain,
            }}
            message={(<span>Something went wrong</span>)}
            error={products.error}
          />
        </StyledEINSolePropPage>
      );
    }
    if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-3") {
      return (
        <StyledEINSolePropPage>
          <ErrorMessageReflection3
            showOK={{
              text: "Try Again",
              onClick: handleTryAgain,
            }}
            message={(<span>Something went wrong</span>)}
            error={products.error}
          />
        </StyledEINSolePropPage>
      );
    }
    if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-4") {
      return (
        <StyledEINSolePropPage>
          <ErrorMessageReflection4
            showOK={{
              text: "Try Again",
              onClick: handleTryAgain,
            }}
            message={(<span>Something went wrong</span>)}
            error={products.error}
          />
        </StyledEINSolePropPage>
      );
    }
    return (
      <StyledEINSolePropPage>
        <ErrorMessage
          showOK={{
            text: "Try Again",
            onClick: handleTryAgain,
          }}
          message={(<span>Something went wrong</span>)}
          error={products.error}
        />
      </StyledEINSolePropPage>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "federaltaxid") {
    return (
      <StyledEINSolePropPageFederal>
        <ProgressSectionFederal
          mobile={isMobile}
          currentStep={1}
          steps={FEDERAL_APPLICATION_STEPS}
          currentSubStep={state.step}
          maxSubStep={7}
        />
        <FormSectionFederal
          mobile={isMobile}
          path={router.pathname}
          values={state}
          onChange={handleChange}
          onSubmit={handleSubmit}
          onBack={handleBackStep}
        />
      </StyledEINSolePropPageFederal>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "fileforein") {
    return (
      <StyledEINSolePropPageFederal>
        <ProgressSectionFileforein
          mobile={isMobile}
          currentStep={1}
          steps={FEDERAL_APPLICATION_STEPS}
          currentSubStep={state.step}
          maxSubStep={7}
        />
        <FormSectionFileforein
          mobile={isMobile}
          path={router.pathname}
          values={state}
          onChange={handleChange}
          onSubmit={handleSubmit}
          onBack={handleBackStep}
        />
      </StyledEINSolePropPageFederal>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-1") {
    return (
      <StyledEINSolePropPageReflection1>
        <ProgressSectionReflection1
          mobile={isMobile}
          currentStep={1}
          steps={REFLECTION_1_APPLICATION_STEPS}
          currentSubStep={state.step}
          maxSubStep={7}
        />
        <FormSectionReflection1
          mobile={isMobile}
          path={router.pathname}
          values={state}
          onChange={handleChange}
          onSubmit={handleSubmit}
          onBack={handleBackStep}
        />
      </StyledEINSolePropPageReflection1>
    );
  }

  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-2") {
    return (
      <StyledEINSolePropPageReflection2>
        <ProgressSectionReflection2
          mobile={isMobile}
          currentStep={1}
          steps={REFLECTION_2_APPLICATION_STEPS}
          currentSubStep={state.step}
          maxSubStep={7}
        />
        <FormSectionReflection2
          mobile={isMobile}
          path={router.pathname}
          values={state}
          onChange={handleChange}
          onSubmit={handleSubmit}
          onBack={handleBackStep}
        />
      </StyledEINSolePropPageReflection2>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-3") {
    return (
      <StyledEINSolePropPageReflection3>
        <ProgressSectionReflection3
          mobile={isMobile}
          currentStep={1}
          steps={REFLECTION_3_APPLICATION_STEPS}
          currentSubStep={state.step}
          maxSubStep={7}
        />
        <FormSectionReflection3
          mobile={isMobile}
          path={router.pathname}
          values={state}
          onChange={handleChange}
          onSubmit={handleSubmit}
          onBack={handleBackStep}
        />
      </StyledEINSolePropPageReflection3>
    );
  }
  if (process.env.NEXT_PUBLIC_REACT_APP_SKIN === "reflection-4") {
    return (
      <StyledEINSolePropPageReflection4>
        <ProgressSectionReflection4
          mobile={isMobile}
          currentStep={1}
          steps={REFLECTION_4_APPLICATION_STEPS}
          currentSubStep={state.step}
          maxSubStep={7}
        />
        <FormSectionReflection4
          mobile={isMobile}
          path={router.pathname}
          values={state}
          onChange={handleChange}
          onSubmit={handleSubmit}
          onBack={handleBackStep}
        />
      </StyledEINSolePropPageReflection4>
    );
  }
  return (
    <StyledEINSolePropPage>
      <BasicHeaderSection
        title="Step 1: Enter Sole Proprietor Information"
        subtitle="2025 Sole Proprietor Tax ID / SS-4 Form"
      />
      <FormSection
        path={router.pathname}
        values={state}
        onChange={handleChange}
        onSubmit={handleSubmit}
      />
    </StyledEINSolePropPage>
  );
}

export default EINSolePropPage;
